import { render, staticRenderFns } from "./PointHarmony.vue?vue&type=template&id=53d0a547&"
import script from "./PointHarmony.vue?vue&type=script&lang=js&"
export * from "./PointHarmony.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d0a547')) {
      api.createRecord('53d0a547', component.options)
    } else {
      api.reload('53d0a547', component.options)
    }
    module.hot.accept("./PointHarmony.vue?vue&type=template&id=53d0a547&", function () {
      api.rerender('53d0a547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/Points/PointHarmony.vue"
export default component.exports